import { render } from "./CpuSockets.vue?vue&type=template&id=8e504f48&scoped=true"
import script from "./CpuSockets.vue?vue&type=script&lang=js"
export * from "./CpuSockets.vue?vue&type=script&lang=js"

import "./CpuSockets.vue?vue&type=style&index=0&id=8e504f48&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e504f48"]])

export default __exports__